import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { placeOrder, loadCart, setPaymentCode, getFinalCart, finalSettle } from '../redux/actions/cart'
import { useHistory, Redirect } from 'react-router-dom'
import { allOrdersTotalSelector } from '../redux/reducers/cart';
import { getData } from '../redux/actions/restaurant';
import { formatPrice, getNoPaymentMerchantIds } from '../common/Functions';

function Payment({ placeOrder, cartTotal, loadCart, error, setPaymentCode, payment, orderRedirect, orderid, finalCartResponse,
    getFinalCart, totalAll, finalSettle, getData, merchant_disabled_cod, payment_list, offline_payment_list, merchantId }) {
    const history = useHistory();
    const noPayment = getNoPaymentMerchantIds();
    useEffect(() => {
        if (finalCartResponse.orders.length == 0) {
            getFinalCart();
        }
        if (noPayment.indexOf(merchantId) != -1) {
            finalSettle()
        }
        
        getData();
    }, [])

    const close = () => {
        history.push("/finalcart");
    }

    if (orderRedirect) {
        return <Redirect to={`/order/${orderid}`} />
    }



    return (
        <>
            <header className="fixed header-blue">
                <div className="container">
                    <div className="header-top">
                        <div className="header-top-left">
                            <span className="back"><img className="img-dark" src="/images/arrow-back.png" alt="" />
                                <img className="img-white" src="/images/arrow-back-white.png" alt="" onClick={close} />
                            </span>
                        </div>
                        <div className="header-top-mid">
                            <span className="font-semibold">Payment</span>
                        </div>
                        <div className="header-top-right"></div>
                    </div>
                </div>
            </header>
            <div className="payment-main" style={{ marginTop: "51px" }}>
                <div className="payment-content">
                    <div className="payment-content-head">
                        <h2>Pay {formatPrice(totalAll)}</h2>
                    </div>
                    <div className="payment-options">
                        <h3>Payment Options</h3>
                        <p className="text-grey">Select any one option</p>
                        <div className="payment-options-list">
                            {!merchant_disabled_cod && <div className="payment-option">
                                <div className="custom-checkbox round  pr-10">
                                    <input type="radio" name="payment" checked={payment == "cod"} value="cod" onChange={(e) => setPaymentCode(e.target.value)} />
                                    <span className="checkmark"></span>
                                </div>
                                <span>Cash</span>
                            </div>}
                            {payment_list && payment_list.map(paymentMapped => <div className="payment-option" key={paymentMapped.value}>
                                <div className="custom-checkbox round  pr-10">
                                    <input type="radio" name="payment" checked={payment == paymentMapped.value} value={paymentMapped.value} onChange={(e) => setPaymentCode(e.target.value)} />
                                    <span className="checkmark"></span>
                                </div>
                                <span>{paymentMapped.label}</span>
                            </div>)}
                            {offline_payment_list && offline_payment_list.map(paymentMapped => <div className="payment-option" key={paymentMapped}>
                                <div className="custom-checkbox round  pr-10">
                                    <input type="radio" name="payment" checked={payment == paymentMapped} value={paymentMapped} onChange={(e) => setPaymentCode(e.target.value)} />
                                    <span className="checkmark"></span>
                                </div>
                                <span>Offline - {paymentMapped}</span>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <footer>
                <div className="bottom-action" onClick={() => finalSettle()}>
                    <div className="left">
                        <p className="text-white"><span className="text-white d-inline-block pr-10">Total</span><span className="font-bold">{formatPrice(totalAll)}</span></p>

                    </div>
                    <div className="right">
                        <button className="btn-bottom text-white">Proceed to Pay <span className="fa fa-long-arrow-right"></span></button>
                    </div>
                </div>
            </footer>
        </>
    )
}

const mapStateToProps = (state) => ({
    cartTotal: state.cart.serverCart?.cart?.grand_total?.amount_pretty,
    error: state.cart.error,
    payment: state.cart.payment,
    orderRedirect: state.cart.orderRedirect,
    orderid: state.cart.orderid,
    merchantId: state.restaurant.merchant_id,
    finalCartResponse: state.cart.finalCartResponse,
    totalAll: allOrdersTotalSelector(state),
    payment_list: state.restaurant.details?.payment_list,
    offline_payment_list: state.restaurant.details?.offline_payments,
    merchant_disabled_cod: state.restaurant.details?.merchant_disabled_cod
})

export default connect(mapStateToProps, { placeOrder, loadCart, setPaymentCode, getFinalCart, finalSettle, getData })(Payment)
